import api from '..';
import { IMessage } from '../messages';
import { IUser } from '../user';

// Ensure ISMSMessage extends IMessage
export interface ISMSMessage extends IMessage {
  body: string;
  id: number;
  content: string;
  sender: IUser;
  recipient?: IUser;
  sender_id: number;
  recipient_id?: number;
  sender_number: string;
  recipient_number: string;
  sms_provider_id: number;
  meta: {
    sid: string | null;
    status: 'queued' | 'delivered' | 'failed';
  };
}

export interface ISMSMessageResponse extends IMessage {
  sms_messages: ISMSMessage[];
  min_id: number;
  max_id: number;
}
export interface ISMSMessagePost {
  recipient_id: number;
  body: string;
}

export const SMSApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSMS: builder.query<any, [string]>({
      query: ([client_id]) => `/sms_messages/client/${client_id}?limit=10`,
      providesTags: () => [{ type: 'SMS', id: 'LIST' }],
      transformResponse: (res: ISMSMessageResponse) => {
        return {
          sms_messages: res.sms_messages,
          max_id: res.max_id,
          min_id: res.min_id,
        };
      },
    }),
    getPreviousSMS: builder.query<ISMSMessageResponse, [number, string]>({
      query: ([client_id, start_from]) =>
        `/sms_messages/client/${client_id}?direction=previous&start_from=${start_from}&limit=5`,
      providesTags: () => [{ type: 'SMS', id: 'LIST' }],
    }),
    getNextSMS: builder.query<ISMSMessageResponse, [string, string]>({
      query: ([client_id, start_from]) =>
        `/sms_messages/client/${client_id}?direction=next&start_from=${start_from}&limit=5`,
      providesTags: () => [{ type: 'SMS', id: 'LIST' }],
    }),
    sendSMS: builder.mutation({
      query: (sms_message: ISMSMessagePost) => ({
        url: `/sms_messages`,
        method: 'POST',
        body: { sms_message },
      }),
      invalidatesTags: [{ type: 'SMS', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetSMSQuery,
  useLazyGetSMSQuery,
  useGetPreviousSMSQuery,
  useLazyGetPreviousSMSQuery,
  useGetNextSMSQuery,
  useLazyGetNextSMSQuery,
  useSendSMSMutation,
} = SMSApi;
